// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","pageLoader":"App_pageLoader__T1q6x","spinner":"App_spinner__bIZjU","spin":"App_spin__Lgf8x"};